
@if (asmStringCheck()) {
  <div class="text-center no-statments">
    You are not eligible to view statements
  </div>
}
@if (restrictToTen && !asmStringCheck()) {
  <div class="row">
    <div class="col-sm-5 offset-sm-7 d-flex justify-content-end statements">
      RECENT STATEMENTS
    </div>
  </div>
}
@if (!asmStringCheck()) {
  <section class="row makePaymentView" id="productList-area">
    <section class="{{ statementWidth }} table-s-section" [ngClass]="{ 'acc-overview-sp': showSection === true }">
      <section class="credits-section" [ngClass]="{ 'acc-overview-sp': showSection === true }">
        <section class="row">
          <section class="col-sm-12 col-md-6 align-self-center credits-section__heading"
            [ngClass]="{ 'acc-overview-sp': showSection === true }">
            <h3 class="oi-table-title" [ngClass]="{ 'acc-overview-sp': showSection === true }">
              {{ "statements.statementList.title" | cxTranslate }}
            </h3>
          </section>
          <section
            class="col-md-6 col-12 col-xs-12 col-sm-12 d-flex justify-content-end align-items-center credits-section__btns">
            <button type="button" (click)="viewCurrent()" class=" btn-primary mr-3"
              [ngClass]="{ 'acc-overview-sp': showSection === true }">
              {{ "statements.statementList.view_text" | cxTranslate }}
            </button>
            <button type="button" (click)="viewPDF()" class=" btn-primary pdf"
              [ngClass]="{ 'acc-overview-sp': showSection === true }">
              <img [src]="'/icons/'+baseSiteId+'/pdf.svg'" alt="pdf" class="pdf imgPdf" />
              <span class="pdfText">
                {{"statements.statementList.pdf_text" | cxTranslate }}
              </span>
            </button>
          </section>
        </section>
        @if (baseSiteId == 'vsh') {
          <small>For further historical statements, please contact 1-800-VACCINES (1-800-822-2463)</small>
        }
        @if (baseSiteId != 'vsh') {
          <small>For further historical statements, please contact 1-800-752-9338</small>
        }
      </section>
      <section class="payment-section position-relative min-height-500" [ngClass]="{ 'acc-overview-sp': showSection === true }">
        @if (!statementsData) {
          <mat-spinner class="spinner absolute top200" mode="indeterminate" diameter="100"></mat-spinner>
        }
        @if ((statementsData?.dateMap | json) != '{}') {
          <table aria-describedby="creditsTable" id="applyCreditsTable" class="credits-table table table-striped"
            >
            @if (statementsData) {
              <thead>
                <tr>
                  <th scope="col" class="statement" [ngClass]="{ 'acc-overview-sp': showSection === true }">
                    {{
                    "statements.statementList.statement_table_label" | cxTranslate
                    }}&nbsp;
                  </th>
                  <th scope="col" class="text-right" [ngClass]="{ 'acc-overview-sp': showSection === true }"></th>
                  <th scope="col" [ngClass]="{ 'acc-overview-sp': showSection === true }"></th>
                </tr>
              </thead>
            }
            <tbody>
              @for (data of (restrictToTen ? statementsData?.dateMap?.entry?.slice(0,8) : statementsData?.dateMap?.entry); track data; let i = $index) {
                <tr
                  >
                  <td>
                    <span>{{  formatDate(data?.value) | date: "MM/dd/yyyy" }} to {{ formatDate(data?.key) | date: "MM/dd/yyyy" }} </span>
                  </td>
                  <td>
                    <a title="view statement link" (click)="openNewModalPopup(formatDate(data.key))" role="button" class="view-link">{{
                    "statements.statementList.view_text" | cxTranslate }}</a>
                  </td>
                  <td>
                    <a title="download PDF link" role="button" (click)="generateSavePdf(formatDate(data.key))"><img
                      [src]="'/icons/'+baseSiteId+'/pdf.svg'" alt="pdf" class="pdf-design" />{{
                      "statements.statementList.pdf_text"
                    | cxTranslate }}</a>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
        @if (false) {
          <table aria-describedby="statementsTable" id="applyStatementsTable"
            class="credits-table table table-striped">
            <tr class="sample-header">
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
            @for (data of statementsData?.dateMap?.entry; track data; let i = $index) {
              <tr>
                <td class="two-column-lay header">
                  {{ "statements.statementList.statement_table_label" | cxTranslate }}
                </td>
                <td class="two-column-lay">
                  <span>{{ data?.key | date: "MM/dd/yyyy" }} to {{ data?.value | date: "MM/dd/yyyy" }}</span>
                </td>
                <td class="two-column-lay header"></td>
                <td class="two-column-lay">
                  <a title="view statement link" (click)="openNewModalPopup(data.key)" class="view-link">{{
                  "statements.statementList.view_text" | cxTranslate }}</a>
                </td>
                <td class="two-column-lay header"></td>
                <td class="two-column-lay">
                  <a title="download PDF link" (click)="generateSavePdf(data.key)"><img src="/icons/pdf.png"
                    alt="pdf" class="pdf-design" />{{ "statements.statementList.pdf_text" |
                  cxTranslate }}</a>
                </td>
              </tr>
            }
          </table>
        }
      </section>
    </section>
  </section>
}
@if (restrictToTen && statementsData?.dateMap?.entry?.length > 0 && !asmStringCheck()) {
  <div class="invoice-btngrps">
    <button type="button" class="btn-primary" data-di-id="di-id-41a05d18-6b04a424"
      [routerLink]="['/my-account/statements']">
      {{
      "accountOverview.Financials.statements.statement_btn_txt"
      | cxTranslate
      }}
    </button>
  </div>
}
@if (showPortal) {
  <section id="temp-pdf">
    <app-statement-display [statement]="details" [toShow]="showModal"></app-statement-display>
  </section>
}
